import { UITypes } from "types"
import TemperatureScale from "types/enums/TemperatureScale"

import { getRoundedTemperature } from "utils/getRoundedTemperature"
import parseCelsiusToFahrenheit from "utils/parseCelsiusToFahrenheit"

/**
 * Formats a performance test's start→end temperature change for display/export,
 * converting from Celsius to the user's scale. A null scale is treated as
 * Fahrenheit (the app's default). Returns "" when start or end is missing.
 */
export const getPerfTestTempChange = (item: UITypes.RowSettings["item"], scale: TemperatureScale | null): string => {
  const { start, end } = item.perftest
  if (!start || !end) return ""

  const mark = scale === TemperatureScale.CELSIUS ? "C" : "F"
  const format = (celsius: number) =>
    getRoundedTemperature(scale === TemperatureScale.CELSIUS ? celsius : parseCelsiusToFahrenheit(celsius), 1, true)

  return `From ${format(start)} ${mark} to ${format(end)} ${mark}`
}
